import React from 'react';
import PropTypes from 'prop-types';
import './products-dropdown.scss';

// Product IDs used for tracking and keys
const PRODUCT_IDS = {
  FAX: 'fax',
  SIGN: 'sign',
  SIGN_API: 'sign-api',
  DASH: 'dash',
};

// Product configuration - names are intentionally hardcoded as product names, not brand references
const PRODUCTS = [
  {
    id: PRODUCT_IDS.FAX,
    name: 'Fax',
    url: 'https://sign.dropbox.com/products/dropbox-fax',
  },
  {
    id: PRODUCT_IDS.SIGN,
    name: 'Sign',
    url: 'https://sign.dropbox.com/products/dropbox-sign',
  },
  {
    id: PRODUCT_IDS.SIGN_API,
    name: 'Sign API',
    url: 'https://sign.dropbox.com/products/dropbox-sign-api',
  },
  {
    id: PRODUCT_IDS.DASH,
    name: 'Dash',
    url: 'https://dash.dropbox.com/',
  },
];

const ProductsDropdown = ({ isOpen, daCategory }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <nav className="products-dropdown" role="menu">
      <div className="products-dropdown__wrapper">
        {PRODUCTS.map((product) => (
          <a
            key={product.id}
            className="products-dropdown__link"
            href={product.url}
            role="menuitem"
            tabIndex="0"
            da-category={daCategory}
            da-action={`product_${product.id}`}
            da-label={product.name}
          >
            <div>{product.name}</div>
          </a>
        ))}
      </div>
    </nav>
  );
};

ProductsDropdown.propTypes = {
  isOpen: PropTypes.bool,
  daCategory: PropTypes.string,
};

ProductsDropdown.defaultProps = {
  isOpen: false,
  daCategory: 'menu',
};

export default ProductsDropdown;
